import React from "react";
import HeaderEN from "../components/en/HeaderEN";
import HeroSectionEN from "../components/en/HeroSectionEN";
import SeasonBannerEN from "../components/en/SeasonBannerEN";
import PresentationSectionEN from "../components/en/PresentationSectionEN";
import GardenSectionEN from "../components/en/GardenSectionEN";
import AmenitiesSectionEN from "../components/en/AmenitiesSectionEN";
import ActivitiesSectionEN from "../components/en/ActivitiesSectionEN";
import PricingSectionEN from "../components/en/PricingSectionEN";
import ReviewsSectionEN from "../components/en/ReviewsSectionEN";
import FAQSectionEN from "../components/en/FAQSectionEN";
import ContactFormSectionEN from "../components/en/ContactFormSectionEN";
import ContactInfoSectionEN from "../components/en/ContactInfoSectionEN";
import FooterEN from "../components/en/FooterEN";

const HomePageEN = () => {
  return (
    <div className="min-h-screen">
      {/* Header avec navigation sémantique */}
      <HeaderEN />
      
      {/* Main content avec structure sémantique */}
      <main role="main">
        {/* Hero Section - Section principale */}
        <HeroSectionEN />

        {/* Bandeau saison / tarif en cours */}
        <SeasonBannerEN />
        
        {/* Section de présentation */}
        <PresentationSectionEN />

        {/* Section Jardin - expérience */}
        <GardenSectionEN />
        
        {/* Section des équipements */}
        <AmenitiesSectionEN />
        
        {/* Section des activités */}
        <ActivitiesSectionEN />
        
        {/* Section des tarifs */}
        <PricingSectionEN />
        
        {/* Section des avis clients */}
        <ReviewsSectionEN />
        
        {/* Section FAQ */}
        <FAQSectionEN />
        
        {/* Section de contact avec formulaire */}
        <ContactFormSectionEN />
        
        {/* Section d'informations de contact avec carte */}
        <ContactInfoSectionEN />
      </main>
      
      {/* Footer avec signature VibeSite */}
      <FooterEN />
    </div>
  );
};

export default HomePageEN;